var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxOnSmall = function SvgCheckboxOnSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 5,
    fill: "#006BE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.838 5.38a.583.583 0 0 1 .825.824l-.413-.412-.412-.413Zm-6.005 6.003 6.005-6.004.412.413.412.412-6.416 6.417a.583.583 0 0 1-.825 0L4.504 9.704a.583.583 0 1 1 .825-.825l2.504 2.505Z",
    fill: "#fff"
  })));
};
export default SvgCheckboxOnSmall;